import {
  ADD_SEQUENCE,
  UPDATE_CHAPTER,
  UPDATE_STEP,
  ADD_STEP,
  UPDATE_ACTION,
  UPDATE_STEP_EDIT,
  RESET_STAGE,
  UPDATE_SEQUENCE,
  ADD_ACTION,
} from "./sequenceActionType";

const initialState = {
  stage: {
    stagePath: [],
    SequenceList: [],
    actionsList: [],
  },
};

const resetStageData = () => ({
  chapterEdit: {
    ...initialState.stage.chapterEdit,
    steps: [],
  },
  actionEdit: initialState.stage.actionEdit,
  stagePath: [], // Réinitialisation
});

// Fonction générique pour ajouter ou mettre à jour une action dans une étape
const updateActionInStep = (sequenceList, stepId, actionId, actionData) => {
  return sequenceList.map((sequence) => {
    const updatedSteps = sequence.chapterEdit.steps.map((step) => {
      if (step.id === stepId) {
        const updatedActions = step.actions.map((action) => {
          if (action.id === actionId) {
            return { ...action, ...actionData }; // Met à jour l'action existante
          }
          return action;
        });

        if (!updatedActions.some(action => action.id === actionId)) {
          updatedActions.push(actionData); // Si l'action n'existe pas, on l'ajoute
        }

        return { ...step, actions: updatedActions };
      }
      return step;
    });

    return { ...sequence, chapterEdit: { ...sequence.chapterEdit, steps: updatedSteps } };
  });
};

const sequenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CHAPTER:
      return {
        ...state,
        stage: {
          ...state.stage,
          chapterEdit: {
            ...state.stage.chapterEdit,
            ...action.payload,
          },
        },
      };

    case UPDATE_STEP_EDIT:
      return {
        ...state,
        stage: {
          ...state.stage,
          stepEdit: {
            ...state.stage.stepEdit,
            ...action.payload,
          },
        },
      };

    case UPDATE_ACTION: {
      const { stepId, actionId, updatedActionData } = action.payload;
      const updatedSequenceList = updateActionInStep(state.stage.SequenceList, stepId, actionId, updatedActionData);

      return {
        ...state,
        stage: {
          ...state.stage,
          SequenceList: updatedSequenceList,
        },
      };
    }

    case ADD_ACTION: {
      const { actionData } = action.payload;

      return {
        ...state,
        stage: {
          ...state.stage,
          actionsList: [...state.stage.actionsList, actionData],
          actionEdit: initialState.stage.actionEdit,
        },
      };
    }

    case "ADD_ACTION_TO_STEP":
      console.log('stepId:', action.payload.stepId); // Vérifie la valeur du stepId ici
      console.log('Steps avant modification:', state.stage?.SequenceList?.chapterEdit?.steps);

      if (!state.stage?.SequenceList?.chapterEdit?.steps) {
        console.error("steps est undefined dans le state");
        return state;
      }

      return {
        ...state,
        stage: {
          ...state.stage,
          SequenceList: {
            ...state.stage.SequenceList,
            chapterEdit: {
              ...state.stage.SequenceList.chapterEdit,
              steps: state.stage.SequenceList.chapterEdit.steps.map((step) => {
                if (step.id === action.payload.stepId) {
                  return {
                    ...step,
                    actions: [...(step.actions || []), action.payload.action],
                  };
                }
                return step;
              }),
            },
          },
        },
      };




    case ADD_STEP: {
      const { id, contents } = action.payload;

      const newStep = { id, ...contents };

      const lastIndex = state.stage.SequenceList.length - 1;
      const lastSequence = state.stage.SequenceList[lastIndex];

      const updatedSteps = [...lastSequence.chapterEdit.steps];
      const existingStepIndex = updatedSteps.findIndex((step) => step.id === id);

      if (existingStepIndex !== -1) {
        updatedSteps[existingStepIndex] = newStep;
      } else {
        updatedSteps.push(newStep);
      }

      const updatedSequenceList = [...state.stage.SequenceList];
      updatedSequenceList[lastIndex] = {
        ...lastSequence,
        chapterEdit: { ...lastSequence.chapterEdit, steps: updatedSteps },
      };

      return {
        ...state,
        stage: {
          ...state.stage,
          SequenceList: updatedSequenceList,
        },
      };
    }

    case UPDATE_STEP:
      return {
        ...state,
        stage: {
          ...state.stage,
          chapterEdit: {
            ...state.stage.chapterEdit,
            steps: state.stage.chapterEdit.steps.map((step, idx) =>
              idx === action.payload.stepIndex ? { ...step, ...action.payload.stepEdit } : step
            ),
          },
        },
      };

    case ADD_SEQUENCE:
      return {
        ...state,
        stage: {
          ...state.stage,
          SequenceList: [
            ...state.stage.SequenceList,
            {
              id: Date.now(),
              chapterEdit: action.payload.chapterEdit,
              stagePath: action.payload.stagePath || [],
            },
          ],
        },
      };

    case UPDATE_SEQUENCE:
      return {
        ...state,
        stage: {
          ...state.stage,
          SequenceList: state.stage.SequenceList.map((sequence, idx) =>
            idx === action.payload.index
              ? { chapterEdit: { ...action.payload.updatedChapter }, stagePath: action.payload.updatedStagePath || [] }
              : sequence
          ),
        },
      };

    case RESET_STAGE:
      return initialState;

    case "UPDATE_STEPS_WITH_ACTION":
      return {
        ...state,
        stage: {
          ...state.stage,
          steps: action.payload,
        },
      };

    default:
      return state;
  }
};

export default sequenceReducer;


//Creators :Léo Yang @3DDGAMES -- Under license